import { API_URL } from "../../../../constants";
import * as httpNetworking from "../../../../httpNetworking";

const URL = API_URL + "/user/auth/password/update";
const VERSION = 0;

export type UpdatePasswordResponse =
    | {
          success: true;
      }
    | {
          success: false;
          issue: string;
          field: "oldPassword" | "newPassword";
      };

export default async function updatePassword(
    oldPassword: string,
    newPassword: string
): Promise<UpdatePasswordResponse> {
    const options: httpNetworking.POSTRequestConfig = {
        timeout: 50000
    };
    const params = {
        oldPassword,
        newPassword
    };

    const response = (await httpNetworking.simplePOSTRequest(URL, params, options, VERSION)).data;
    return response;
}
